import { render, staticRenderFns } from "./BsCardBody.vue?vue&type=template&id=a6b2f03c&scoped=true&"
import script from "./BsCardBody.vue?vue&type=script&lang=js&"
export * from "./BsCardBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b2f03c",
  null
  
)

export default component.exports